import * as AppTip from "./app_tips.js";

export function initPopovers() {
  document.addEventListener('click', (evt) => {
    let el = evt.target;
    if (!el || !el.dataset || !el.dataset.toggle || el.dataset.toggle !== 'popover')
      return;

    const $this = evt.target,
      $target = document.getElementById($this.getAttribute("aria-controls"));

    function _closePopover(_target, _this, _pKeyupFunction) {
      _target.classList.remove("on");
      _this.setAttribute('aria-expanded', "false");

      if (_pKeyupFunction) {
        document.onkeyup = _pKeyupFunction;
      }
    }

    //close if open
    if ("true" === $this.getAttribute('aria-expanded')) {
      _closePopover($target, $this);
    } else {
      //open the popover
      $this.setAttribute('aria-expanded', "true");
      $target.classList.add("on");

      let pKeyupFunction;

      if (document.onkeyup) {
        pKeyupFunction = document.onkeyup;
      }

      //bind escape and close button to close
      $target.querySelectorAll('[data-close="popover"]').forEach(el => {
        el.addEventListener('click', function (evt) {
          evt.preventDefault();
          // Do not stop propagation because will prevent app tip or other listeners from
          // triggering
          _closePopover($target, $this, pKeyupFunction);
        }, { passive: false });
      });
      document.onkeyup = function (event) {
        if (event.keyCode === 27) {
          _closePopover($target, $this, pKeyupFunction);
        }
      };
    }
  });
}

export function initTriggerlessPopovers() {
  document.querySelectorAll('[data-toggle="triggerless-popover"]').forEach(el => {
    const appTipId = el.dataset['appTipId'];
    //console.log("app-tip-id:", appTipId);
    if (appTipId && appTipId !== '')
      AppTip.initAppTip(appTipId);

    el.querySelectorAll('[data-close="popover"]').forEach(cel => {
      cel.addEventListener('click', function (evt) {
        evt.preventDefault();
        // Do not stop propagation because will prevent app tip or other listeners from
        // triggering
        let closeParent = cel.closest(".ul-popover");
        if(closeParent.classList.contains("on")) {
          closeParent.classList.remove("on");
        }
        else {
          closeParent.setAttribute("style","display: none;");
        }
        closeParent.setAttribute("aria-hidden", "true");
      });
    });
  });
}

